module.exports = __webpack_public_path__ + "img/水21.509057e8.png";